import { render, staticRenderFns } from "./GiftCodeError.vue?vue&type=template&id=287abba0&scoped=true&"
import script from "./GiftCodeError.vue?vue&type=script&lang=js&"
export * from "./GiftCodeError.vue?vue&type=script&lang=js&"
import style0 from "./GiftCodeError.vue?vue&type=style&index=0&id=287abba0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "287abba0",
  null
  
)

export default component.exports